import api from './api';
import DateHelper from '../utils/dateHelper';
import { DADOS_PARAMETRIZADOS_MODEL } from '../utils/models';
import { DADOS_PARAM_ROUTE, ALERTAS_ROUTE } from '../constants/apiRoutes';

function createDadosParametrizados(dadoParametrizado) {
	const dadoConfigurado = {
		...dadoParametrizado,
	};

	if ((dadoConfigurado.horaOcorrencia !== undefined) && (dadoConfigurado.horaOcorrencia !== null)) {
		dadoConfigurado.horaOcorrencia = DateHelper.convertStringDate(
			dadoConfigurado.horaOcorrencia,
			'HH:mm',
			'HH:mm:ss',
		);
	}

	if ((dadoConfigurado.horaInicial !== undefined) && (dadoConfigurado.horaInicial !== null)) {
		dadoConfigurado.horaInicial = DateHelper.convertStringDate(
			dadoConfigurado.horaInicial,
			'HH:mm',
			'HH:mm:ss',
		);
	}

	dadoConfigurado.categoria =
		// eslint-disable-next-line
		dadoParametrizado.categoria && dadoParametrizado.categoria.id != 0
			? dadoParametrizado.categoria
			: null;

	dadoConfigurado.confianca =
		// eslint-disable-next-line
		dadoParametrizado.confianca && dadoParametrizado.confianca.id != 0
			? dadoParametrizado.confianca
			: null;

	dadoConfigurado.iniciador =
		// eslint-disable-next-line
		dadoParametrizado.iniciador && dadoParametrizado.iniciador.id != 0
			? dadoParametrizado.iniciador
			: null;

	dadoConfigurado.severidade =
		// eslint-disable-next-line
		dadoParametrizado.severidade && dadoParametrizado.severidade.id != 0
			? dadoParametrizado.severidade
			: null;

	dadoConfigurado.urgencia =
		// eslint-disable-next-line
		dadoParametrizado.urgencia && dadoParametrizado.urgencia.id != 0
			? dadoParametrizado.urgencia
			: null;

	return dadoConfigurado;
}

function convertDatasDadosParametrizados(dadoParametrizado) {
	if (dadoParametrizado.horaOcorrencia) {
		dadoParametrizado.horaOcorrencia = DateHelper.convertStringDate(
			dadoParametrizado.horaOcorrencia,
			'HH:mm',
			'HH:mm:ss',
		);
	}

	if (dadoParametrizado.dataOcorrencia) {
		dadoParametrizado.dataOcorrencia = DateHelper.convertStringDate(
			dadoParametrizado.dataOcorrencia,
			'DD/MM/YYYY',
			'YYYY-MM-DD',
		);
	}

	if (dadoParametrizado.dataInicial) {
		dadoParametrizado.dataInicial = DateHelper.convertStringDate(
			dadoParametrizado.dataInicial,
			'DD/MM/YYYY',
			'YYYY-MM-DD',
		);
	}

	if (dadoParametrizado.dataFinal) {
		dadoParametrizado.dataFinal = DateHelper.convertStringDate(
			dadoParametrizado.dataFinal,
			'DD/MM/YYYY',
			'YYYY-MM-DD',
		);
	}
}

export default {
	saveDadosParametrizados(values, cb) {
		const dados = createDadosParametrizados(values);

		/* Callback usado para atualizar o card na etapa audiencia */
		cb();

		return api.post(DADOS_PARAM_ROUTE.SAVE_DADOS_PARAMETRIZADOS, dados);
	},

	async findAlertaById(id) {
		const { data } = await api.get(ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', id));

		let { dadoParametrizado } = data;

		/* Caso não hover dados parametrizados cadastrados ainda, aplica o modelo */
		dadoParametrizado = dadoParametrizado || DADOS_PARAMETRIZADOS_MODEL;

		/* Seta o id do alerta, se utilizado o modelo */
		dadoParametrizado.alertaId = data.id;

		/* Seta o status atual do alerta, provavelmente por causa do visualizar */
		dadoParametrizado.alertaStatus = data.statusAtualAlerta;

		convertDatasDadosParametrizados(dadoParametrizado);

		return dadoParametrizado;
	},
};
